<template>
	<section class="djcontainer">
		<slot></slot>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "AdaptiveContainer",
});
</script>
